import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

import { APP_ROUTES } from '@/shared/config/routes-config';
import { UserRole } from '@/shared/enums/user-role.enum';
import { UserTeams } from '@/shared/enums/user-teams.enum';
import DefaultLayout from '@/shared/layouts/default/default.layout';

const CorporateTrackingDashboardContainer = React.lazy(
  () => import('../../containers/corporate-tracking-dashboard/corporate-tracking-dashboard.container')
);

const CorporateOrganizationsContainer = React.lazy(
  () => import('../../containers/corporate-organizations/corporate-organizations.container')
);

export const CorporateRoutesConfig: RouteObject[] = [
  {
    index: true,
    element: <Navigate to={APP_ROUTES.CORPORATE_DASHBOARD_MODULE.FULL_PATH} />
  },
  {
    path: APP_ROUTES.CORPORATE_DASHBOARD_MODULE.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[
            UserRole.SUPER_ADMIN,
            UserRole.ADMIN,
            UserRole.SALES_MANAGER,
            UserRole.SALES_AGENT,
            UserRole.E_COMMERCE_MANAGER,
            UserRole.OPERATION_MANAGER
          ]}
          component={CorporateTrackingDashboardContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: APP_ROUTES.CORPORATE_ORGANIZATIONS_MODULE.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[
            UserRole.SUPER_ADMIN,
            UserRole.ADMIN,
            UserRole.SALES_MANAGER,
            UserRole.SALES_AGENT
          ]}
          permittedTeamsList={[UserTeams.CORPORATE]}
          component={CorporateOrganizationsContainer}
        />
      </React.Suspense>
    )
  }
];
